import EditProjectModal from './editProject';

export {
    EditProjectModal
}


// WEBPACK FOOTER //
// ./src/scenes/analysis/components/modals/index.js